import { Link } from "react-router-dom";
import { useT } from "../i18n/index.js";

interface Crumb {
  label: string;
  to?: string;
}

interface AdminPageShellProps {
  crumbs: Crumb[];
  children: React.ReactNode;
}

const s = {
  root: {
    minHeight: "100svh",
    background: "var(--bg)",
    display: "flex",
    flexDirection: "column" as const,
  },
  nav: {
    display: "flex",
    alignItems: "center",
    padding: "0 var(--space-lg)",
    height: "52px",
    background: "var(--surface)",
    borderBottom: "1px solid var(--border)",
    boxShadow: "var(--shadow-sm)",
    flexShrink: 0,
  },
  ol: {
    display: "flex",
    alignItems: "center",
    gap: "0.375rem",
    listStyle: "none",
    margin: 0,
    padding: 0,
    flexWrap: "wrap" as const,
    fontSize: "var(--text-sm)",
  },
  homeLink: {
    minHeight: "44px",
    display: "inline-flex",
    alignItems: "center",
    fontWeight: 800,
    fontSize: "var(--text-sm)",
    color: "var(--brand-dk)",
    textDecoration: "none",
    letterSpacing: "-0.01em",
  },
  sep: {
    color: "var(--text-dim)",
    userSelect: "none" as const,
    fontSize: "0.7rem",
    lineHeight: 1,
  },
  crumbLink: {
    minHeight: "44px",
    display: "inline-flex",
    alignItems: "center",
    color: "var(--brand)",
    textDecoration: "none",
    fontWeight: 500,
  },
  crumbCurrent: {
    minHeight: "44px",
    display: "inline-flex",
    alignItems: "center",
    color: "var(--text-mid)",
    fontWeight: 600,
  },
  content: {
    flex: 1,
  },
};

export function AdminPageShell({ crumbs, children }: AdminPageShellProps) {
  const t = useT();
  return (
    <div style={s.root}>
      <nav style={s.nav} aria-label={t("admin.breadcrumb")}>
        <ol style={s.ol}>
          <li>
            <Link to="/" style={s.homeLink}>HootApp</Link>
          </li>
          {crumbs.map((crumb, i) => (
            <li
              key={crumb.label}
              style={{ display: "flex", alignItems: "center", gap: "0.375rem" }}
            >
              <span style={s.sep} aria-hidden="true">›</span>
              {crumb.to ? (
                <Link to={crumb.to} style={s.crumbLink}>{crumb.label}</Link>
              ) : (
                <span
                  style={s.crumbCurrent}
                  aria-current={i === crumbs.length - 1 ? "page" : undefined}
                >
                  {crumb.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <div style={s.content}>
        {children}
      </div>
    </div>
  );
}
